(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ns-product-certificate]';

  function getCertificateMap(root) {
    if (root.__nsCertificateMap) {
      return root.__nsCertificateMap;
    }

    var dataElement = root.querySelector(
      '[data-ns-certificate-variants]'
    );

    if (!dataElement) {
      root.__nsCertificateMap = {};
      return root.__nsCertificateMap;
    }

    try {
      root.__nsCertificateMap = JSON.parse(
        dataElement.textContent
      );
    } catch (error) {
      root.__nsCertificateMap = {};

      console.warn(
        'NS product certificate data could not be read.',
        error
      );
    }

    return root.__nsCertificateMap;
  }

  function getSelectedVariantId(root) {
    var section = root.closest('.shopify-section') || document;
    var variantInputs = section.querySelectorAll(
      'form[action*="/cart/add"] [name="id"]'
    );

    for (var index = 0; index < variantInputs.length; index += 1) {
      if (
        !variantInputs[index].disabled &&
        variantInputs[index].value
      ) {
        return String(variantInputs[index].value);
      }
    }

    var variantFromUrl = new URL(
      window.location.href
    ).searchParams.get('variant');

    return variantFromUrl ||
      root.dataset.initialVariantId ||
      '';
  }

  function updateCertificate(root, variantId) {
    if (!root) return;

    var certificateMap = getCertificateMap(root);
    var selectedVariantId = String(
      variantId || getSelectedVariantId(root) || ''
    );
    var certificateUrl = certificateMap[selectedVariantId];
    var link = root.querySelector(
      '[data-ns-certificate-link]'
    );

    if (!link) return;

    if (certificateUrl) {
      link.href = certificateUrl;
      root.hidden = false;
    } else {
      link.removeAttribute('href');
      root.hidden = true;
    }
  }

  function updateAll(scope, variantId) {
    var context = scope || document;

    if (
      context.matches &&
      context.matches(ROOT_SELECTOR)
    ) {
      updateCertificate(context, variantId);
    }

    context
      .querySelectorAll(ROOT_SELECTOR)
      .forEach(function (root) {
        updateCertificate(root, variantId);
      });
  }

  function scheduleUpdate(scope) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        updateAll(scope);
      });
    });
  }

  function getVariantIdFromEvent(event) {
    if (!event.detail) return '';

    var variant =
      event.detail.variant ||
      event.detail;

    return variant && variant.id
      ? String(variant.id)
      : '';
  }

  function handleVariantEvent(event) {
    var section = event.target.closest
      ? event.target.closest('.shopify-section')
      : null;

    var scope = section || document;
    var variantId = getVariantIdFromEvent(event);

    if (variantId) {
      updateAll(scope, variantId);
    } else {
      scheduleUpdate(scope);
    }
  }

  function init() {
    updateAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'change',
    function (event) {
      var section = event.target.closest
        ? event.target.closest('.shopify-section')
        : null;

      if (
        !section ||
        !section.querySelector(ROOT_SELECTOR)
      ) {
        return;
      }

      scheduleUpdate(section);
    }
  );

  [
    'variant:change',
    'product:variant-change',
    'product:variant-changed',
    'theme:variant:change'
  ].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      handleVariantEvent
    );
  });

  window.addEventListener(
    'popstate',
    function () {
      scheduleUpdate(document);
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      updateAll(event.target);
    }
  );
})();